export default __webpack_public_path__ + "static/media/obiwezy.c4dc52d2.webp";